var map = {
	"./1.png": [
		1336,
		336
	],
	"./2.png": [
		47,
		47
	],
	"./3.png": [
		7323,
		323
	],
	"./4.png": [
		7807,
		807
	],
	"./5.png": [
		1597,
		597
	],
	"./6.png": [
		7013,
		13
	],
	"./7.png": [
		9923,
		923
	],
	"./8.png": [
		6181,
		181
	],
	"./9.png": [
		9989,
		989
	],
	"./arrow.png": [
		7192
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 6511;
module.exports = webpackAsyncContext;